import { Alert, Card, Conditional } from '@payaca/ambrosia';

const EnaFormFooter: React.FC<{
  isDirty: boolean;
  isSavingChanges: boolean;
  errorMessage: string | undefined;
}> = ({ isDirty, isSavingChanges, errorMessage }) => {
  return (
    <Conditional condition={!!(errorMessage || isDirty)}>
      <Card className="sticky bottom-0">
        <Card.Body className="flex flex-col justify-center gap-2">
          {errorMessage && (
            <Alert
              colour="red"
              className="max-h-24 overflow-scroll sm:max-h-none sm:overflow-auto"
            >
              <p>{errorMessage}</p>
            </Alert>
          )}

          <span className="text-center text-gray-600">
            {isDirty &&
              (isSavingChanges ? 'Changes saving...' : 'Changes saved.')}
          </span>
        </Card.Body>
      </Card>
    </Conditional>
  );
};

export default EnaFormFooter;
